import Typography, { TypographyProps } from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';

interface OwnProps extends TypographyProps {}

interface ProviderNameTextProps extends OwnProps {}

const ProviderNameTextBase: FunctionComponent<
  ProviderNameTextProps
> = props => <Typography variant="subheading" lineClamp {...props} />;

export const ProviderNameText = pure(ProviderNameTextBase);

ProviderNameText.displayName = 'ProviderNameText';
